import React from "react";
import { Navigate, Route } from "react-router-dom";
import HomeCard from "./components/publicEmployees/HomeCard";
import BillingPage from "./components/publicEmployees/BillingPage";
import PaymentSuccess from "./components/publicEmployees/PaymentSuccess";
import BusinessCardScanner from "./components/publicEmployees/BusinessCardScanner";

// Child routes of "/" for an individual (public employee) account: Home and Billing.
// The screens that used to be separate pages are folded into Home (card, style, details)
// and Billing (plan, history); their old URLs still resolve so bookmarks and links keep working.
export const renderIndividualChildRoutes = () => (
  <>
    <Route index element={<HomeCard />} />
    <Route path="subscription" element={<BillingPage />} />
    <Route path="subscriptionSuccess" element={<PaymentSuccess />} />
    <Route path="business-cards" element={<BusinessCardScanner />} />
    <Route path="transaction-history" element={<Navigate to="/subscription?view=history" replace />} />
    <Route path="details" element={<Navigate to="/" replace />} />
    <Route path="theme" element={<Navigate to="/" replace />} />
    <Route path="customize-card" element={<Navigate to="/" replace />} />
  </>
);
